<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.batchDocuments}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="batch.batchName | safeHtml"></span>
	</h5>
</div>
<div class="dx-properties dx-table-entries modal-body">
  <div style="max-height:600px;overflow-y:auto;overflow-x:hidden">
                <div>
                  <div class="col-sm-12 col-md-12">
                    <table *ngIf="batch.documents && batch.documents.length > 0" class='table table-hover table-condensed dx-table'>
                      <thead>
                         <tr>
                         	<th>{{LOCALIZATION.document}}</th>
                         	<th class="hidden-sm hidden-xs" *ngFor='let metadata of batch.batchMetadataDisplay'>{{metadata.label}}</th>
							<th>Process ID</th>
                            <th>{{LOCALIZATION.taskStatus}}</th>
                            <th class="hidden-sm hidden-xs">{{LOCALIZATION.dueDate}}</th>                            
                            <th>Current Task / Owner</th>
                         	<th class="hidden-sm hidden-xs">{{LOCALIZATION.pages}}</th>
                         	<th class="hidden-sm hidden-xs">{{LOCALIZATION.ocrScore}}</th>                            
                            <th>Result</th>
                            <th>Download</th>
                         </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor='let d of batch.documents'>
                          <td class="truncate">
							<span title="{{d.productTitle}}"
								class='dd-text-collapse' 
								ddTextCollapse
								[ddTextCollapseMaxLength]="80" 
								[ddTextCollapseText]="d.productTitle">
							</span>                           	
                          </td>
                          <td class="hidden-sm hidden-xs" *ngFor='let metadata of d.productMetadataDisplay'>{{metadata.value}}</td>                          
						  <td class="truncate"><a class="pointMe" (click)="openProcessDiagram(d.jbpmProcessId, d.productTitle)" title="Live process diagram">{{d.jbpmProcessId}}</a></td>
                          <td><p class="truncate" title="{{d.state}}">{{d.state}}</p></td>
                          <td class="hidden-sm hidden-xs"><p class="truncate" title="{{batch.dueDateStr || LOCALIZATION.none}}">{{batch.dueDateStr || LOCALIZATION.none}}</p></td> 
                          <td>
                          	<span *ngIf="d.currentTaskName">
                          		<a class="truncate pointMe" title="{{LOCALIZATION.viewDetails}}" (click)="showTaskProperties(d.currentTaskId)">{{d.currentTaskName}}</a>
                          	</span>
                          	<span *ngIf="!d.currentTaskName">{{LOCALIZATION.none}}</span>
                          	<span> / {{d.currentTaskOwner || LOCALIZATION.none}}</span>
                          </td>
                          <td class="hidden-sm hidden-xs"><p class="truncate" title="{{d.productPages}}">{{d.productPages}}</p></td>
                          <td class="hidden-sm hidden-xs"><p class="truncate" title="{{d.productOCRScore}}">{{d.productOCRScore}}</p></td>                          
                          <td>
                            <!-- Displays the review decision, or any explicit task data, eg. SF715 -->
                          	<div style="text-transform:capitalize;">
	                          	<span *ngIf="'COMPLETED' == d.state">
	                          		<span style="margin-right:4px;">{{d.declassTaskData.finalResult || d.declassTaskData.taskResult}}</span>
	                            </span>
                            </div>
                            <span *ngIf="'COMPLETED' != d.state">{{LOCALIZATION.unavailable}}</span>
                          </td>
                          <td>
                          	<div class="dx-downloads">
	                          	<span *ngIf="'COMPLETED' == d.state && d.jobId != null && (userPermissions['ROLE_PRODUCT_VIEW'] || userPermissions['ROLE_PRODUCT_VIEW_RESTRICTED'])">
	                          		<a *ngFor='let t of downloadJobTypes' 
		                          		class="pointMe" style="margin-bottom:2px;" 
		                          		(click)="downloadResults(d.jobId, d.productTitle, t)" 
		                          		title="{{t.label}}">
		                          		{{t.label}}
	                          		</a>
	                            </span>
                            </div>
                            <span *ngIf="'COMPLETED' != d.state || d.jobId == null">{{LOCALIZATION.resultsEmpty}}</span>
                          </td>                          
                        </tr>
                      </tbody>
                     </table>
                    <div *ngIf="!batch.documents || batch.documents.length == 0"> <i>{{LOCALIZATION.resultsEmpty}}</i></div>
                </div>
              </div>	
  </div>
</div>
<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>
